__turbopack_context__.v({
  "badges": "AppTagCell-module__X7HgtW__badges",
  "badgesOverflow": "AppTagCell-module__X7HgtW__badgesOverflow",
  "root": "AppTagCell-module__X7HgtW__root",
});
